import styled from 'styled-components';

export const UploadPsaVideoButton = styled.button<{ disabled: boolean; hovered?: boolean }>`
  width: 10rem;
  height: 6rem;
  border-radius: 0.8rem;
  background: linear-gradient(135deg, #f5f5f5 0%, #eaeaea 50%, #f5f5f5 100%);
  box-shadow: ${({ hovered }) =>
    hovered ? '0 0.3rem 0.6rem rgba(0, 0, 0, 0.08)' : '0 0.2rem 0.4rem rgba(0, 0, 0, 0.05)'};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.05);

  background-size: 200% 200%;
  display: grid;
  place-items: center;
  padding: 0;
  transition: all 0.3s ease;
  background-position: ${({ hovered }) => (hovered ? 'right bottom' : 'left top')};
  transform: ${({ hovered }) => (hovered ? 'translateY(-0.1rem)' : 'translateY(0)')};

  &:active {
    transform: translateY(0);
    box-shadow: 0 0.1rem 0.2rem rgba(0, 0, 0, 0.05);
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;

export const UploadModalContainer = styled.div`
  display: grid;
  place-items: center;
  padding: 2rem;
`;

export const SelectFileContainer = styled.div`
  margin-bottom: 3rem;
`;

export const SelectFileButton = styled.button<{ disabled?: boolean; variant?: 'secondary' }>`
  padding: 1rem;
  min-width: 9.5rem;
  background-color: ${({ variant }) => (variant === 'secondary' ? '#fff' : '#D34612')};
  color: ${({ variant }) => (variant === 'secondary' ? '#164036' : '#fff')};
  border: ${({ variant }) =>
    variant === 'secondary' ? '2px solid #164036' : '2px solid transparent'};
  border-radius: 0.5rem;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-weight: 600;
  gap: 1.5rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ variant }) => (variant === 'secondary' ? '#164036' : '#C8370F')};
    color: ${({ variant }) => (variant === 'secondary' ? '#fff' : '#fff')};
  }
`;

export const NoFileSelected = styled.p`
  margin: 0;
`;

export const SelectedVideoWrapper = styled.div``;

export const SelectedVideoContainer = styled.div`
  padding: 1rem;
  border: 1px solid #000;
  border-radius: 0.8rem;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 5fr 1fr;
  gap: 1rem;
`;

export const UploadVideoThumbnail = styled.img`
  width: 70px;
  height: 50px;
  object-fit: cover;
  border: 2px solid #000;
  border-radius: 6px;
`;

export const SelectedVideoImageContainer = styled.div`
  display: flex;
`;

export const SelectedVideoImageInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SelectedVideoImageActions = styled.div`
  display: grid;
  place-items: center;
`;

export const FileName = styled.h3`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
`;

export const FileSize = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 400;
`;

// simple small circle loader for button
export const CircleLoader = styled.div`
  border: 1.5px solid rgba(0, 0, 0, 0);
  border-left: 1.5px solid #fff;
  border-radius: 50%;
  width: 1.3rem;
  height: 1.3rem;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ProgressBar = styled.div<{ progress: number }>`
  width: 100%;
  height: 10px;
  border-radius: 10px;
  margin-top: 1rem;
  background-color: #e0e0e0;

  &::after {
    content: '';
    display: block;
    height: 100%;
    width: ${({ progress }: { progress: number }) => `${progress}%`};
    background-color: #d34613;
    border-radius: 10px;
    transition: width 0.5s ease-in-out;
  }
`;

export const MessageContainer = styled.div`
  display: grid;
  place-items: center;

  & > p {
    margin: 0;
    margin-top: 2rem;
    text-align: center;
    font-size: 1.4rem;
  }
`;
